import { CalBooking } from '../Booking/CalBooking';
export { studioMonth, shiftMonth, calCheckoutUrl } from '../Booking/CalBooking';

export function CampaignBooking({ event, navigate }: {
  event: 'photography' | 'film'; navigate?: (url: string) => void;
}) {
  return <CalBooking event={event} theme="campaign" navigate={navigate} />;
}
